module.exports = __webpack_public_path__ + "media/images/products/longlife/longlife-menu-img-3-2a1a8db69bf15cd601f8c2db45e5cd31.png";